import React, { useState } from 'react';
import { Button, Logo, Card, Divider, Drawer } from '../components/components';
import { PageContainer, Footer, Navbar, useWindowWidth } from '../layout/layouts';
import { theme } from '../styles/theme';

export const Landing: React.FC = () => {
  const width = useWindowWidth();
  const isMobile = width < 768;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <PageContainer>
      <Navbar>
        {isMobile ? (
          <Button variant="outline" onClick={() => setIsMenuOpen(true)} style={{ padding: '0 12px' }}>
            ☰ Menu
          </Button>
        ) : (
          <div style={{ display: 'flex', gap: theme.spacing.sm }}>
            <Button variant="ghost">Home</Button>
            <Button variant="ghost">Features</Button>
            <Button variant="ghost">Pricing</Button>
            <Button onClick={() => window.location.href = '/login'}>Sign In</Button>
          </div>
        )}
      </Navbar>

      {/* Mobile Navigation Drawer */}
      <Drawer isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} position="right" title="Navigation">
        <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md, padding: theme.spacing.md }}>
          <Button variant="ghost" fullWidth onClick={() => setIsMenuOpen(false)}>Home</Button>
          <Button variant="ghost" fullWidth onClick={() => setIsMenuOpen(false)}>Features</Button>
          <Button variant="ghost" fullWidth onClick={() => setIsMenuOpen(false)}>Pricing</Button>
          <Divider />
          <Button fullWidth onClick={() => window.location.href = '/login'}>Sign In</Button>
        </div>
      </Drawer>

      <div style={{ padding: isMobile ? `${theme.spacing.xl} 0` : `${theme.spacing.xxl} 0`, textAlign: 'center' }}>
        <h1 style={{ 
          fontSize: isMobile ? '32px' : '48px', 
          lineHeight: theme.typography.lineHeight.tight,
          fontWeight: theme.typography.fontWeight.bold, 
          margin: 0, 
          color: theme.colors.primary 
        }}>
          Enterprise OS for Coaching Institutes
        </h1>
        <p style={{ 
          fontSize: isMobile ? theme.typography.fontSize.sm : theme.typography.fontSize.lg, 
          color: theme.colors.textSecondary, 
          marginTop: theme.spacing.md, 
          maxWidth: '600px', 
          marginLeft: 'auto', 
          marginRight: 'auto' 
        }}>
          Stream lectures securely, run offline synchronization backup, and automate CRM/admissions for your academy under single-tenant SLA parameters.
        </p>
        <div style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          gap: theme.spacing.md, 
          justifyContent: 'center', 
          marginTop: theme.spacing.xl,
          alignItems: isMobile ? 'stretch' : 'center',
          maxWidth: isMobile ? '300px' : 'none',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          <Button onClick={() => window.location.href = '/register'}>Create Institute Profile</Button>
          <Button variant="outline">Schedule Live Demo</Button>
        </div>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: theme.spacing.lg, 
        marginTop: isMobile ? theme.spacing.xl : theme.spacing.xxl 
      }}>
        <Card hoverable>
          <div style={{ fontSize: '32px' }}>🔒</div>
          <h3 style={{ margin: `${theme.spacing.sm} 0` }}>Forensic Watermarking</h3>
          <p style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.textSecondary, margin: 0 }}>
            Dynamic overlays showing IP address and email to prevent recording leaks.
          </p>
        </Card>
        <Card hoverable>
          <div style={{ fontSize: '32px' }}>⚡</div>
          <h3 style={{ margin: `${theme.spacing.sm} 0` }}>Instant Website Builder</h3>
          <p style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.textSecondary, margin: 0 }}>
            Auto-generate custom domains and branding configurations for student catalog discovery.
          </p>
        </Card>
        <Card hoverable>
          <div style={{ fontSize: '32px' }}>📲</div>
          <h3 style={{ margin: `${theme.spacing.sm} 0` }}>Multi-Tenant CRM</h3>
          <p style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.textSecondary, margin: 0 }}>
            Track leads, admissions pipelines, and sandbox Razorpay checkouts flawlessly.
          </p>
        </Card>
      </div>

      <Divider />
      <Footer />
    </PageContainer>
  );
};

export default Landing;
